"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'paymch',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        page: 1,
        total: 10
      }
    };
  },
  computed: {
    agentInfo: function agentInfo() {
      return this.$store.state.user.agentInfo;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
    * 切换商户号
    */
    switchmch: function switchmch(row) {
      var _this = this;
      var that = this;
      this.$alert('确定切换到该商户号吗？', '切换商户号', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            _this.loadObj = _this.$loading({
              lock: true,
              text: '正在提交~~~',
              spinner: 'el-icon-loading'
            });
            _this.$post('WxOpen/switchPayMch', {
              id: row.id
            }).then(function (res) {
              _this.$message({
                message: '切换成功',
                type: 'success'
              });
            }).catch(function (err) {
              _this.loadObj.close();
            });
          }
        }
      });
    },
    /**
     * 设置为提现商户号
     */
    settxmch: function settxmch(row) {
      var _this2 = this;
      var that = this;
      this.$alert('确定设置为提现商户号吗？', '设置为提现商户号', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            _this2.loadObj = _this2.$loading({
              lock: true,
              text: '正在提交~~~',
              spinner: 'el-icon-loading'
            });
            _this2.$post('WxOpen/settxmch', {
              id: row.id
            }).then(function (res) {
              _this2.$message({
                message: '切换成功',
                type: 'success'
              });
            }).catch(function (err) {
              _this2.loadObj.close();
            });
          }
        }
      });
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this3 = this;
      var url = 'WxOpen/getWxPayMchList';
      var listQuery = Object.assign({}, this.listQuery, {
        page: this.listQuery.page - 1
      });
      this.$get(url, this.listQuery).then(function (res) {
        _this3.listLoading = false;
        _this3.list = res.list;
        _this3.listQuery.total = res.total;
      }).catch(function () {
        _this3.listLoading = false;
      });
    }
  }
};